<template>
<div class="container">
    <div id="detail" v-if="page == 'detail'">
        <div class="row">
            <div class="col-12 px-0">
                <img :src="event.cover_image" class="img-fluid">
            </div>
            <div class="col-12 mt-3">
                金牛獻瑞！「港人講地」仝人先祝大家牛年大吉，心想事成！今年雖然大家都要在疫情中過新年，但歡樂氣氛不應因為疫情而減弱，因此「港人講地」趁新春期間推出「氣勢如牛齊集氣」打氣活動，邀請「港人講地」會員發揮創意和心思許下新年願望，新一年向港人打打氣！
            </div>

            <div class="col-12 mt-3">
                <b>玩法：</b>
                <ol>
                    <li>會員登入「港人講地」APP</li>
                    <li>於活動頁內完成問卷可獲港幣$50現金券 (共100份)</li>
                    <li>於創意問答題回答你最有創意和最有心思的願望，將有機會於「港人講地」平台刊載，更有機會獲得大獎港幣$1,000現金券(乙份)。</li>
                </ol>
            </div>

            <div class="col-12">
                <b>活動期：</b>2021年2月10日至21日(年廿九至年初十，共12日)
            </div>

            <div class="col-12 mt-3 mb-5">
                <b>條款及細則：</b>
                <small>
                    <ul>
                        <li>禮品會於活動後起計六星期內以郵寄方式送出</li>
                        <li>所有禮品受有關條款及細則約束</li>
                        <li>活動只限「港人講地」APP會員參與</li>
                        <li>每名會員限參與活動一次</li>
                        <li>會員須確保所提交之個人資料正確</li>
                        <li>會員如被發現有任何被認為提交錯誤或不完整資料或有不誠實行為，將被取消參與活動的資格</li>
                        <li>是次活動的禮品不得轉讓、更換、退回、兌換現金或其他獎品</li>
                        <li>禮品數量有限，換完即止</li>
                        <li>禮品說明/圖片只供參考</li>
                        <li>如有任何爭議，「港人講地」保留最終決定權及解釋權</li>
                    </ul>
                </small>
            </div>
        </div>

        <!-- Check if user is logged in-->
        <div v-if="page == 'detail'">
            <div class="button-container text-center disabled" v-if="!event.started">
                <a class="btn btn-block">活動未開始</a>
            </div>

            <div class="button-container text-center disabled" v-else-if="event.expired">
                <a class="btn btn-block text-danger">活動已過期</a>
            </div>

            <div class="button-container text-center disabled" v-else-if="!loggedIn">
                <a @click="redirectToAppLogin()" class="btn btn-block">登入</a>
            </div>

            <div class="button-container text-center disabled" v-else-if="participated">
                <a class="btn btn-block text-danger">多謝參與此活動</a>
            </div>

            <div class="button-container text-center lunar-new-year-bg" v-else>
                <a class="btn btn-block" @click="participate()">參與活動</a>
            </div>
        </div>
    </div>

    <mobile-verification
        v-if="page == 'mobile-verification' && user.mobile == null"
        @mobileVerified="onMobileVerified">
    </mobile-verification>

    <div id="participate-form" v-if="page == 'participate-form'">
        <div class="row">
            <div class="col-12 px-0">
                <img :src="event.cover_image" class="img-fluid">
            </div>

            <div class="col-12 mt-3">
                <ValidationObserver v-slot="{ invalid }">
                <form @submit.prevent="onFinishedQuestionnaire">
                    <div class="form-group">
                        <label class="question">1. 你平均每星期多常使用「港人講地」App？</label>

                        <ValidationProvider rules="required" v-slot="{ errors }">
                        <div class="options">
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="question_1" id="question_1_option_1" value="1-2天" v-model="questionnaire.question_1">
                                <label class="form-check-label" for="question_1_option_1">
                                    1-2天
                                </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="question_1" id="question_1_option_2" value="3-5天" v-model="questionnaire.question_1">
                                <label class="form-check-label" for="question_1_option_2">
                                    3-5天
                                </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="question_1" id="question_1_option_3" value="6-7天" v-model="questionnaire.question_1">
                                <label class="form-check-label" for="question_1_option_3">
                                    6-7天
                                </label>
                            </div>
                        </div>
                         </ValidationProvider>
                    </div>

                    <div class="form-group">
                        <label class="question">2. 你比較喜歡「港人講地」哪一種類內容？（最多可選三項）</label>

                        <div class="options">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="question_2" id="question_2_option_1"
                                    value="焦點新聞" v-model="questionnaire.question_2">
                                <label class="form-check-label" for="question_2_option_1">
                                    焦點新聞
                                </label>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="question_2" id="question_2_option_2"
                                    value="笑聞一分鐘" v-model="questionnaire.question_2">
                                <label class="form-check-label" for="question_2_option_2">
                                    笑聞一分鐘
                                </label>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="question_2" id="question_2_option_3"
                                    value="港人博評、港人觀點" v-model="questionnaire.question_2">
                                <label class="form-check-label" for="question_2_option_3">
                                    港人博評、港人觀點
                                </label>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="question_2" id="question_2_option_4"
                                    value="港人花生、今日網圖" v-model="questionnaire.question_2">
                                <label class="form-check-label" for="question_2_option_4">
                                    港人花生、今日網圖
                                </label>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="question_2" id="question_2_option_5"
                                    value="有聲專欄" v-model="questionnaire.question_2">
                                <label class="form-check-label" for="question_2_option_5">
                                    有聲專欄
                                </label>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="question_2" id="question_2_option_6"
                                    value="今日直擊" v-model="questionnaire.question_2">
                                <label class="form-check-label" for="question_2_option_6">
                                    今日直擊
                                </label>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="question_2" id="question_2_option_7"
                                    value="焦點．踢爆" v-model="questionnaire.question_2">
                                <label class="form-check-label" for="question_2_option_7">
                                    焦點．踢爆
                                </label>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="question_2" id="question_2_option_8"
                                    value="其他" v-model="questionnaire.question_2">
                                <label class="form-check-label" for="question_2_option_8">
                                    其他
                                </label>
                            </div>
                            </ValidationProvider>

                            <div class="form-row" v-if="question2OtherChecked">
                                <div class="col-12">
                                    <ValidationProvider rules="required: question2OtherChecked" v-slot="{ errors }">
                                    <input type="text" class="form-control" :class="{ 'is-invalid': errors.length > 0 }" name="question_2_other" id="question_2_other" v-model="questionnaire.question_2_other">
                                    </ValidationProvider>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--<div class="form-group">
                        <label class="question">3. 什麼考慮因素會吸引你參與「港人講地」送禮活動。（1 是最重要 - 4 是最不重要）</label>

                        <table class="table options">
                            <thead>
                                <tr>
                                    <td></td>
                                    <td>1</td>
                                    <td>2</td>
                                    <td>3</td>
                                    <td>4</td>
                                </tr>
                            </thead>
                            <tbody>
                                <ValidationProvider rules="required" v-slot="{ errors }" tag="tr">
                                    <td>禮物類型</td>
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="question_3_option_1" id="question_3_option_1_1"
                                                value="1" v-model="questionnaire.question_3.option_1">
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="question_3_option_1" id="question_3_option_1_2"
                                                value="2" v-model="questionnaire.question_3.option_1">
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="question_3_option_1" id="question_3_option_1_3"
                                                value="3" v-model="questionnaire.question_3.option_1">
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="question_3_option_1" id="question_3_option_1_4"
                                                value="4" v-model="questionnaire.question_3.option_1">
                                        </div>
                                    </td>
                                </ValidationProvider>
                                <ValidationProvider rules="required" v-slot="{ errors }" tag="tr">
                                    <td>禮物價值</td>
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="question_3_option_2" id="question_3_option_2_1"
                                                value="1" v-model="questionnaire.question_3.option_2">
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="question_3_option_2" id="question_3_option_2_2"
                                                value="2" v-model="questionnaire.question_3.option_2">
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="question_3_option_2" id="question_3_option_2_3"
                                                value="3" v-model="questionnaire.question_3.option_2">
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="question_3_option_2" id="question_3_option_2_4"
                                                value="4" v-model="questionnaire.question_3.option_2">
                                        </div>
                                    </td>
                                </ValidationProvider>
                                <ValidationProvider rules="required" v-slot="{ errors }" tag="tr">
                                    <td>活動時間</td>
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="question_3_option_3" id="question_3_option_3_1"
                                                value="1" v-model="questionnaire.question_3.option_3">
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="question_3_option_3" id="question_3_option_3_2"
                                                value="2" v-model="questionnaire.question_3.option_3">
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="question_3_option_3" id="question_3_option_3_3"
                                                value="3" v-model="questionnaire.question_3.option_3">
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="question_3_option_3" id="question_3_option_3_4"
                                                value="4" v-model="questionnaire.question_3.option_3">
                                        </div>
                                    </td>
                                </ValidationProvider>
                                <ValidationProvider rules="required" v-slot="{ errors }" tag="tr">
                                    <td>活動複雜性</td>
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="question_3_option_4" id="question_3_option_4_1"
                                                value="1" v-model="questionnaire.question_3.option_4">
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="question_3_option_4" id="question_3_option_4_2"
                                                value="2" v-model="questionnaire.question_3.option_4">
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="question_3_option_4" id="question_3_option_4_3"
                                                value="3" v-model="questionnaire.question_3.option_4">
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="question_3_option_4" id="question_3_option_4_4"
                                                value="4" v-model="questionnaire.question_3.option_4">
                                        </div>
                                    </td>
                                </ValidationProvider>
                            </tbody>
                        </table>
                    </div>-->

                    <div class="form-group">
                        <label class="question">3. 你有從以下平台瀏覽過「港人講地」內容嗎？（可多選）</label>

                        <div class="options">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="question_4" id="question_4_1" value="手機應用程式" v-model="questionnaire.question_4">
                                <label class="form-check-label" for="question_4_1">
                                    手機應用程式
                                </label>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="question_4" id="question_4_2" value="港人講地網站" v-model="questionnaire.question_4">
                                <label class="form-check-label" for="question_4_2">
                                    港人講地網站
                                </label>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="question_4" id="question_4_3" value="Facebook" v-model="questionnaire.question_4">
                                <label class="form-check-label" for="question_4_3">
                                    Facebook
                                </label>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="question_4" id="question_4_4" value="Instagram" v-model="questionnaire.question_4">
                                <label class="form-check-label" for="question_4_4">
                                    Instagram
                                </label>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="question_4" id="question_4_5" value="Youtube" v-model="questionnaire.question_4">
                                <label class="form-check-label" for="question_4_5">
                                    Youtube
                                </label>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="question_4" id="question_4_6" value="微博" v-model="questionnaire.question_4">
                                <label class="form-check-label" for="question_4_6">
                                    微博
                                </label>
                            </div>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="form-group">
                        <label class="question">4. 雖然今年大家要在疫情中過年，但港人抗疫意志不減。請你寫下對香港的新年祝福，為香港人打打氣！最有創意及最有意思的祝福將有機會於「港人講地」平台刊載，更有機會獲得豐富獎品。（限100字內）</label>

                        <ValidationProvider rules="required|max:100" v-slot="{ errors }">
                        <textarea class="form-control" name="question_5" id="question_5" rows="5" maxlength="100" v-model="questionnaire.question_5"></textarea>
                        </ValidationProvider>
                    </div>

                    <button type="submit" class="btn btn-block lunar-new-year-bg" :disabled="invalid">確認</button>
                </form>
                </ValidationObserver>
            </div>
        </div>
    </div>

    <address-confirmation
        v-if="page == 'address-confirmation'"
        @addressConfirmed="onAddressConfirmed"
        :user="user"
    ></address-confirmation>
</div>
</template>

<script>
import Autentication from '../mixins/authentication'
import MobileVerification from '../MobileVerification'
import AddressConfirmation from '../AddressConfirmation'
import RedirectToLogin from '../mixins/redirectToLogin'
import User from '../mixins/user'
import Recaptcha from '../mixins/recaptcha'

export default {
    name: 'LunarNewYear2021',

    mixins: [
        Autentication,
        RedirectToLogin,
        User,
        Recaptcha
    ],

    props: [
        'eventId'
    ],

    components: {
        'mobile-verification': MobileVerification,
        'address-confirmation': AddressConfirmation
    },

    computed: {
        question2OtherChecked() {
            return this.questionnaire.question_2.includes('其他')
        }
    },

    async created() {
        await this.authentication()

        await this.getEvent()

        if (this.loggedIn) {
            await this.getUser()
            await this.isParticipated()
        }
    },

    data() {
        return {
            'page': 'detail',
            'event': {
                expired: false,
                started: false,
            },
            'participated': false,
            'questionnaire': {
                'question_1': null,
                'question_2': [],
                'question_2_other': null,
                // 'question_3': {
                //     'option_1': null,
                //     'option_2': null,
                //     'option_3': null,
                //     'option_4': null,
                // },
                'question_4': [],
                'question_5': null,
                'name': null,
                'address': null
            }
        }
    },

    methods: {
        async getEvent() {
            try {
                const { data } = await axios.get(`/events/${this.eventId}`);
                const { event } = data;

                this.event = event;
            } catch (error) {
                console.log(error)
            }
        },

        async isParticipated() {
            try {
                const { data } = await axios.post(`/events/${this.eventId}/is-participated`);
                const { participated } = data;

                this.participated = participated;
            } catch (error) {
                console.log(error)
            }
        },

        participate() {
            window.scrollTo(0,0);

            if (this.user.mobile == null) {
                this.page = 'mobile-verification'
            } else {
                this.page = 'participate-form'
            }
        },

        onMobileVerified() {
            window.scrollTo(0,0);

            this.page = 'participate-form'
        },

        onFinishedQuestionnaire() {
            window.scrollTo(0,0);

            this.page = 'address-confirmation'
        },

        async onAddressConfirmed(data) {
            const { name, address, set_default_address } = data

            this.questionnaire.name = name
            this.questionnaire.address = address

            try {
                const { data, status } = await axios.post(`/events/${this.event.id}/participate`, {
                    'recaptcha_token': this.recaptcha_token,
                    'set_default_address': set_default_address,
                    'questionnaire': this.questionnaire
                })

                if (status == 200) {
                    this.onParticipated()
                }
            } catch (error) {
                alert('發生錯誤，請稍後再試！')
            }
        },

        onMobileVerified() {
            this.page = 'participate-form'
        },

        onParticipated() {
            Swal.fire({
                title: '多謝參與！',
                text: '得獎者將有專人聯絡領獎',
                confirmButtonText: '好的',

            }).then(() => {
                window.location.href=`/events/${this.event.id}`
            })
        }
    },

    watch: {
        "questionnaire.question_2": (newVal, oldVal) => {
            if (newVal.length >= 3) {
                console.log('selected 3')
                $("input[name='question_2']").not(':checked').prop("disabled", true);
            } else {
                $("input[name='question_2']").not(':checked').prop("disabled", false);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.question {
    font-weight: 700;
}

// .options {
//     font-size: .9rem;
// }

table td {
    text-align: center;
}

.lunar-new-year-bg {
    background: url('/images/lunar_new_year_bg.png') no-repeat;
    background-size: cover;

    color: #000000;
    font-weight: bold;
    font-size: 1.2rem;

    a {
        color: #000000;
        font-weight: bold;
        font-size: 1.2rem;
    }
}
</style>
